import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const DelegationIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9055 5.83404C19.2733 6.16839 19.3004 6.7376 18.9661 7.10539L15.4661 10.9554C15.2945 11.1441 15.051 11.2511 14.796 11.25C14.541 11.2488 14.2985 11.1395 14.1287 10.9493L12.3287 8.93262C11.9977 8.56179 12.03 7.99286 12.4008 7.66187C12.7716 7.33089 13.3406 7.36318 13.6715 7.73401L14.8062 9.00529L17.6342 5.89458C17.9685 5.52678 18.5377 5.49968 18.9055 5.83404Z"
        fill="currentColor"
      />
      <path
        d="M8 9.5C10.0711 9.5 11.75 7.82107 11.75 5.75C11.75 3.67893 10.0711 2 8 2C5.92893 2 4.25 3.67893 4.25 5.75C4.25 7.82107 5.92893 9.5 8 9.5Z"
        fill="currentColor"
      />
      <path
        d="M1 15.5C1 13.2909 2.79086 11.5 5 11.5H11C13.2091 11.5 15 13.2909 15 15.5V18H1V15.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DelegationIcon;
